
const SERVER_PROVIDER_LIST = ['AWS', 'GCP', 'Azure', 'Oracle', 'Baishan', 'Aofei', 'Ucloud', 'Wangsu', 'IBM', 'Conversant', 'GPortal', 'ServersCom', 'Zenlayer', 'Akamai', 'CTEL']

export const getServerProviderList = () => {
  return SERVER_PROVIDER_LIST
}

